var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUcTypo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none",
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FCBE40",
    d: "M3.48.2v12.96c0 .608.12 1.032.36 1.272.256.24.592.36 1.008.36.416 0 .744-.12.984-.36.256-.24.384-.664.384-1.272V.2h2.496v12.792c0 1.36-.336 2.408-1.008 3.144-.656.72-1.632 1.08-2.928 1.08s-2.28-.36-2.952-1.08C1.168 15.4.84 14.352.84 12.992V.2h2.64Zm14.698 10.536v2.232c0 1.36-.336 2.408-1.008 3.144-.656.72-1.632 1.08-2.928 1.08s-2.28-.36-2.952-1.08c-.656-.736-.984-1.784-.984-3.144V4.232c0-1.36.328-2.4.984-3.12.672-.736 1.656-1.104 2.952-1.104s2.272.368 2.928 1.104c.672.72 1.008 1.76 1.008 3.12v1.632h-2.496v-1.8c0-.608-.128-1.032-.384-1.272-.24-.256-.568-.384-.984-.384-.416 0-.752.128-1.008.384-.24.24-.36.664-.36 1.272v9.072c0 .608.12 1.032.36 1.272.256.24.592.36 1.008.36.416 0 .744-.12.984-.36.256-.24.384-.664.384-1.272v-2.4h2.496Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUcTypo);
export default __webpack_public_path__ + "static/media/icon-uc-typo.f4b7f48c.svg";
export { ForwardRef as ReactComponent };